<template>
	<section
		class="media_and_text"
		:style="cssVars"
	>
		<div class="container">
			<div
				class="media_and_text__inner"
				:class="{ flip_horizontally: flip_horizontally }"
			>
				<div
					class="media_and_text__inner__text"
					:class="{ flip_horizontally: flip_horizontally }"
				>
					<div class="inner">
						<div class="content_container">
							<h6
								v-if="subtitle"
								v-html="subtitle"
							></h6>
							<h2
								v-if="title"
								v-html="title"
							></h2>

							<div
								class="body"
								v-if="text"
								v-html="text"
							></div>
						</div>

						<div class="cta_container">
							<primary-button
								v-if="parsedImageOrVideo === 'image' && parsedPrimaryButton || data_source != 'module' && parsedImageOrVideo != 'video' && parsedPrimaryButton"
								:link="parsedPrimaryButton.url ? parsedPrimaryButton : false"
								:label="parsedPrimaryButton.title ? parsedPrimaryButton.title : null"
								:theme="this.text_colour === '#fff' || this.background_colour === '#211752' || this.background_colour === '#4f58f5' ? 'reverse' : 'normal'"
							></primary-button>

							<video-button
								v-else-if="parsedImageOrVideo === 'video'"
								:label="'Play Video'"
								:video_source="parsedVideo"
							></video-button>

							<secondary-button
								v-if="parsedSecondaryButton"
								:link="parsedSecondaryButton"
								:label="data_source === 'module' ? parsedSecondaryButton.title : 'Full Story'"
								:theme="this.text_colour === '#fff' || this.background_colour === '#211752' || this.background_colour === '#4f58f5' ? 'reverse' : 'normal'"
							></secondary-button>
						</div>
					</div>
				</div>

				<template v-if="parsedImageOrVideo === 'video'">
					<div
						class="media_and_text__inner__image"
						:class="{ flip_horizontally: flip_horizontally }"
						v-if='parsedVideoPoster'
					>
						<img
							:src="parsedVideoPoster.url ? parsedVideoPoster.url : parsedVideoPoster"
							:alt="title"
							:class="{ flip_horizontally: flip_horizontally }"
						/>
					</div>
				</template>
				<template v-else>
					<div
						class="media_and_text__inner__image"
						:class="{ flip_horizontally: flip_horizontally }"
						v-if='parsedImage'
					>
						<img
							:src="parsedImage.url ? parsedImage.url : parsedImage"
							:alt="title"
							:class="{ flip_horizontally: flip_horizontally }"
						/>
					</div>
				</template>
			</div>
		</div>
	</section>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';
import VideoButton from './VideoButton.vue';

export default {
	data() {
		return {
			theModalStatus: false,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		title: {},
		subtitle: {},
		tag: {},
		text: {},
		primary_button: {},
		secondary_button: {},
		image: {},
		video: {},
		video_poster: {},
		image_or_video: {},
		text_alignment: {},
		flip_horizontally: {},
		size: {},
		data_source: {},
		text_colour: {},
		background_colour: {},
	},

	computed: {
		fadeDirection() {
			if (this.flip_horizontally === '1') {
				return 'fade-left';
			} else {
				return 'fade-right';
			}
		},

		fadeDirectionAlt() {
			if (this.flip_horizontally === '1') {
				return 'fade-right';
			} else {
				return 'fade-left';
			}
		},

		parsedImage() {
			if (this.image) {
				try {
					return JSON.parse(this.image);
				} catch (e) {
					return this.image;
				}
			} else {
				return null;
			}
		},

		parsedVideoPoster() {
			if (this.video_poster) {
				return JSON.parse(this.video_poster);
			} else {
				return null;
			}
		},

		parsedVideo() {
			if (this.video) {
				try {
					return JSON.parse(this.video);
				} catch (e) {
					return this.video;
				}
			} else {
				return null;
			}
		},

		parsedPrimaryButton() {
			if (this.primary_button) {
				try {
					return JSON.parse(this.primary_button);
				} catch (e) {
					return this.primary_button;
				}
			} else {
				return null;
			}
		},

		parsedSecondaryButton() {
			if (this.secondary_button) {
				return JSON.parse(this.secondary_button);
			} else {
				return null;
			}
		},

		parsedImageOrVideo() {
			if (this.image_or_video) {
				try {
					return JSON.parse(this.image_or_video);
				} catch (e) {
					return this.image_or_video;
				}
			} else {
				return null;
			}
		},

		flipHorizontally() {
			if (this.flip_horizontally === '1') {
				return 'Yes';
			} else {
				return 'No';
			}
		},

		cssVars() {
			return {
				'--text-alignment': this.text_alignment
					? this.text_alignment
					: 'center',
				'--white': this.background_colour,
				'--text-colour': this.text_colour,
				'--size': '2 / span 10',
			};
		},
	},

	watch: {},

	methods: {
		getModalData(arg) {
			this.theModalStatus = arg;
			return arg;
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {
		SecondaryButton,
		PrimaryButton,
		VideoButton,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.media_and_text {
	/* max-height: 500px; */
	overflow: hidden !important;
	background-color: var(--background-colour);

	@media (max-width: $mobile-xl) {
		max-height: unset;
		overflow-x: hidden;
		padding: 0;
	}

	.container {
		position: relative;
		padding-top: 0;
		padding-bottom: 0;
		/* padding-left: 0;
		padding-right: 0; */

		/* @media (max-width: $mobile-xl) {
			padding-top: 0;
			padding-bottom: 0;
			padding-left: var(--gutter-mobile);
			padding-right: var(--gutter-mobile);
		} */

		@media (max-width: $mobile-xl) {
			/* padding: 0; */
			margin: 0;
			max-width: 100%;
		}
	}

	&__inner {
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		column-gap: 0;
		row-gap: 30px;
		grid-column: span 12;
		position: relative;
		overflow: hidden;
		padding: 24px 0;

		@media (max-width: $mobile-xl) {
			border-radius: 0;
		}

		.device {
			position: absolute;
			left: unset;
			top: 0;
			right: 0;
			margin-left: unset;
			height: calc(100% + 2px);
			margin-top: -3px;
			margin-right: -3px;
			-webkit-transform: scaleX(-1);
			transform: scaleX(-1);

			@media (max-width: $mobile-xl) {
				height: unset !important;
				width: 100%;
			}
		}

		@media (max-width: $mobile-xl) {
			grid-template-columns: 1fr 1fr;
			grid-column: 1 / span 4;
		}

		&.flip_horizontally {
			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
				border-radius: 0 0 0 0;
			}

			.device {
				position: absolute;
				top: 0;
				left: 0;
				height: calc(100% + 2px);
				margin-top: -3px;
				margin-left: -3px;
				-webkit-transform: unset;
				transform: unset;
			}
		}

		@media (max-width: $mobile-xl) {
			grid-template-columns: 1fr;
			column-gap: 0;
			// row-gap: var(--spacer);
			grid-column: span 4;
		}

		.video {
			grid-column: 6 / span 7;
			aspect-ratio: 690 / 470;
			position: relative;
			height: 500px;
			overflow: hidden;
			position: relative;
			z-index: 5;
			/* border-left: var(--border); */

			@media (max-width: $mobile-xl) {
				height: 240px;
				border-left: unset;
				/* border-bottom: var(--border); */
			}

			&.flip_horizontally {
				order: 0;
				justify-content: flex-end;
				grid-column: 1 / span 7;
				border-left: unset;
				/* border-right: var(--border); */

				@media (max-width: $mobile-xl) {
					order: 0;
					margin-right: 0;
					min-height: auto;
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
				margin-right: 0;
				min-height: auto;
			}
		}

		&__image {
			grid-column: 7 / span 5;
			opacity: 1;
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			align-items: center;
			box-sizing: border-box;
			/* height: 480px; */
			aspect-ratio: 1 / 1;
			/* height: 447px; */
			/* overflow: hidden; */
			border-radius: 50%;
			overflow: hidden;
			position: relative;
			z-index: 5;

			@media (max-width: $mobile-xl) {
				height: unset;
				/* aspect-ratio: 312 / 264; */
				border-left: unset;
				padding-right: unset;
				/* padding: 24px 24px 0; */
				/* max-width: calc(100% - 48px); */
				/* border-bottom: var(--border); */
			}

			&.flip_horizontally {
				order: 0;
				justify-content: flex-end;
				grid-column: 1 / span 5;
				border-left: unset;
				/* padding: 48px 0 48px 48px; */
				padding-right: unset;
				aspect-ratio: 1 / 1;
				border-radius: 50%;
				overflow: hidden;
				position: relative;
				/* border-right: var(--border); */

				@media (max-width: $mobile-xl) {
					order: 1;
					margin-right: 0;
					min-height: auto;
					padding-left: unset;
					/* padding: 24px 24px 0;
					aspect-ratio: 312 / 264; */
					/* max-width: calc(100% - 48px); */
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 7;
				margin-right: 0;
				min-height: auto;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				transition: 0.2s ease all;
				transform: scale(1);
				object-position: top;
				position: relative;
				z-index: 10;
			}
		}

		&__text {
			grid-column: 1 / span 5;
			background: transparent 0% 0% no-repeat padding-box;
			opacity: 1;
			display: flex;
			flex-direction: column;
			gap: var(--gutter-tablet-desktop);
			font: normal normal normal 17px/24px var(--primary-font-family);
			/* padding: 100px 0 100px; */
			gap: 50px;
			/* background: var(--white); */
			z-index: 5;

			@media (max-width: $mobile-xl) {
				gap: 16px;
				order: 0;
			}

			&.flip_horizontally {
				grid-column: 7 / span 5;
				order: 1;

				@media (max-width: $mobile-xl) {
					order: 0;
					grid-column: span 1;
					margin-right: 0;
					/* aspect-ratio: 4 / 3.5; */
					min-height: auto;
				}

				.inner {
					grid-column: 1 / span 12;
					/* padding: 96px 48px 96px; */

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						/* border-left: var(--border); */
						border-right: unset;
						/* max-width: calc(100% - 48px); */
					}
				}
			}

			h6 {
				font-size: 14px;
				font-style: normal;
				font-weight: 700;
				line-height: 18px; /* 128.571% */
				letter-spacing: 0.4px;
				text-transform: uppercase;
				color: var(--text-colour);
				margin: 0 0 24px;
			}

			h2 {
				color: var(--text-colour);
				margin: 0;
				margin-bottom: 24px;
				z-index: 10;
			}

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
				// padding: 0 var(--spacer);

				h2 {
					text-align: left;
				}

				.the_subtitle {
					text-align: center;
				}
			}

			.wpforms-container-full,
			.wpcf7-form {
				margin-top: var(--spacer);
			}

			.the_subtitle {
				font: normal normal bold 18px/28px var(--primary-font-family);
				z-index: 10;

				&::v-deep {
					p {
						margin: 0 0 32px;
						font: normal normal bold 18px/28px var(--primary-font-family);
						color: var(--text-colour);

						@media (max-width: $mobile-xl) {
							text-align: left;
						}

						&:last-of-type {
							margin: 0 0 0;
						}
					}
				}
			}

			.text,
			.body {
				/* font: normal normal 500 var(--body-font-size)
					var(--primary-font-family); */
				/* color: var(--text-colour); */
				z-index: 10;

				&::v-deep {
					p {
						margin: 0 0 32px;
						font: normal normal normal 16px/24px var(--primary-font-family);
						color: var(--text-colour);

						@media (max-width: $mobile-xl) {
							text-align: left;
						}

						&:last-of-type {
							margin: 0 0 0;
						}
					}

					ul,
					ol {
						display: flex;
						flex-direction: column;
						margin: var(--gutter-tablet-desktop) 0 var(--gutter-tablet-desktop);
						padding: 0 0 0 12px;

						li {
							font: normal normal normal var(--body-font-size)
								var(--primary-font-family);
						}
					}
				}
			}

			.cta_container {
				margin-top: 0;
				/* z-index: 10; */
				/* max-width: calc(100% - calc(113px - 54px)); */
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				gap: 24px;
				min-width: 100%;

				@media (max-width: $mobile-xl) {
					margin-top: (32px - 16px);
					text-align: left;
					display: flex;
					flex-wrap: wrap;
					gap: var(--spacer-mobile);
				}

				/* .site_button,
				.site_button_secondary {
					margin-right: 0;
					border: 1px solid  var(--text-colour);

					&::v-deep {
						span {
							color: var(--text-colour);
						}
					}
				} */

				/* .site_button_primary {
					padding-left: 0;
				} */
			}

			.content_device {
				position: absolute;
				right: 0;
				bottom: 0;

				@media (max-width: $mobile-xl) {
					height: 112px;
				}
			}

			.inner {
				grid-column: 2 / span 12;
				min-height: 200px;
				/* padding: 96px 48px 96px; */
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				gap: 130px;
				pointer-events: all;
				justify-content: var(--text-alignment);
				height: 100%;

				@media (max-width: $mobile-xl) {
					max-height: unset;
					grid-column: span 4;
					border-left: unset;
					/* padding: 48px 24px 48px; */
					/* max-width: calc(100% - 48px); */
					gap: 16px;
				}
			}
		}
	}
}
</style>
